module.exports = __webpack_public_path__ + "media/images/success-2b19d27f0f168600a282bb12e630d961.svg";